/* eslint-disable */
import { routerMiddleware } from 'connected-react-router';
import { applyMiddleware, compose } from 'redux';
import gtmMiddleware from './Middleware/Analytics/Analytics.middleware';
import createDependencyInjectionMiddleware from './Middleware/DependencyInjection/DependencyInjection.middleware';
import createDevtoolsMiddleware from './Middleware/Devtools/Devtools.middleware';
import createLoggerMiddleware from './Middleware/Logger/Logger.middleware';
import redirectToLastVisitedPageForIOSMiddleware from './Middleware/RedirectToLastVisitedPageForIOS/RedirectToLastVisitedPageForIOS.middleware';

/**
 * Create an ehancer
 * https://github.com/reduxjs/redux/blob/master/docs/Glossary.md#store-enhancer
 * @param {Services} services The services to inject into the reducers. **NOT** THE STORE.
 * @param {ReactHistory} history The history implementation
 * @returns {StoreCreator} The function that will be responsbile for _enhancing_ the store
 */
const createEnhancer = (services, history) => {
  const middlewares = [
    gtmMiddleware(services),
    redirectToLastVisitedPageForIOSMiddleware(history),
    routerMiddleware(history),
    process.env.NODE_ENV !== 'test' && createLoggerMiddleware(),
    createDependencyInjectionMiddleware(services),
  ].filter(Boolean)
  return compose(
    applyMiddleware(...middlewares),
    createDevtoolsMiddleware(),
  );
};

export default createEnhancer;
